
import { Prop, Vue, Watch } from "vue-property-decorator";
export default class Tirscript3TableComponent extends Vue {
  @Prop({ type: Array }) items: Object[];
  @Prop({ default: 2, type: Number }) columnGap: number;
  @Prop({ default: 2, type: Number }) rowGap: number;
  @Prop({ default: "", type: String }) templateColumns: string;
  @Prop({ type: Number, default: 0 }) selectLine: number;
  @Prop({ default: true }) light: boolean;
  @Prop({ default: false }) dark: boolean;
  @Prop({ default: false }) w100: boolean;
  @Prop({ type: Boolean, default: false }) mb: boolean;

  selLine = 0;

  styleObject = {};

  @Watch("templateColumns")
  onCangeTemplateColumns() {
    this.styleObject = null;
    this.styleObject = {
      "grid-column-gap": this.columnGap + "px",
      "grid-row-gap": this.rowGap + "px",
      "grid-template-columns": this.templateColumns,
    };
  }

  getInnerTableStyle(idRow: number) {
    let styleInnerObject = {
      "grid-row-start": idRow + 2,
      "grid-row-end": idRow + 2,
      "grid-column-start": 1,
      "grid-column-end": this.templateColumns.split(" ").length + 1,
    };
    return styleInnerObject;
  }

  changeCol(v1: any, v2: any) {
    this.selLine = v1;
    this.$emit("on-click");
    //console.log("table", v1)
  }

  mounted() {
    this.styleObject = {
      "grid-column-gap": this.columnGap + "px",
      "grid-row-gap": this.rowGap + "px",
      "grid-template-columns": this.templateColumns,
    };
    this.selLine = this.selectLine;
    // console.table(this.styleObject)
  }
}
